import { render, staticRenderFns } from "./DetailTourImgDIalog.vue?vue&type=template&id=7fd0ab7a&scoped=true&"
import script from "./DetailTourImgDIalog.vue?vue&type=script&lang=js&"
export * from "./DetailTourImgDIalog.vue?vue&type=script&lang=js&"
import style0 from "./DetailTourImgDIalog.vue?vue&type=style&index=0&id=7fd0ab7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd0ab7a",
  null
  
)

export default component.exports